module.exports = __webpack_public_path__ + "img/pattern1.28c3259.svg";